import { render } from "./CardAi.vue?vue&type=template&id=c916be7c&scoped=true"
import script from "./CardAi.vue?vue&type=script&lang=js"
export * from "./CardAi.vue?vue&type=script&lang=js"

import "./CardAi.vue?vue&type=style&index=0&id=c916be7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c916be7c"

export default script